import React from "react";
import { Card } from "react-bootstrap";

import { EmptyClaimIcon } from "./core/icons";

const NoRecordCard = (): JSX.Element => {
    return (
        <Card className="mt-5 border-0">
            <Card.Body className="px-0 py-0">
                <div className="text-center py-3">
                    <EmptyClaimIcon className="mb-2" />
                    <p className="mb-0">No Records Yet</p>
                </div>
            </Card.Body>
        </Card>
    );
};

export default NoRecordCard;
